export const REDIRECTION_BUTTON_STATUSES = {
  ENABLE: 'enabled',
  DISABLE: 'disabled',
  TIMER: 'timer',
};
